// 1. add 'is-out' class immediately
// 2. remove 'is-in', 'is-active' class immediately
// 3. wait a duration
// 4. then remove 'is-out' classes
// returns delay timeout

export default function ($el, duration, classActive = 'is-active', classIn = 'is-in', classOut = 'is-out', completeCallback = null) {
	$el.classList.add(classOut);
	$el.classList.remove(classActive, classIn);

	const timeout = setTimeout(() => {
		$el.classList.remove(classOut);
		if (completeCallback) {
			completeCallback.apply(null, []);
		}
	}, duration);

	return timeout;
}
